import React from 'react';
import ModalModule from '../modal';
import Utils from '../utils';

const { Modal, ModalButtonActionType } = ModalModule;
const { withLayoutAndModalContexts } = Utils;

const FormsModal = ({ modalId, data }) => {
	const { isReprint, formUrls = [] } = data || {};

	const onClickPrintForms = () => {
		window.open(formUrls[0], '_blank');
	};

	return (
		<Modal
			modalId={modalId}
			className="common-forms-modal"
			header={`${isReprint ? 'Reprint' : 'Print'} Required Forms`}
			primaryButton={{
				type: ModalButtonActionType.Confirm,
				onClick: onClickPrintForms,
				text: 'Print Form(s)',
				dataqa: `${isReprint ? 're' : ''}print-required-forms-modal-print-forms-button`,
			}}
			secondaryButton={{
				type: ModalButtonActionType.Cancel,
				text: isReprint ? "Don't Print" : 'Done',
				dataqa: `${isReprint ? 're' : ''}print-required-forms-modal-done-button`,
			}}
			dataqa={`${isReprint ? 're' : ''}print-required-forms-modal-header`}
		>
			<div className="p-grid">
				<div className="p-col-12">
					Your shipment(s) require you to print additional forms.
					{isReprint && ' Would you like to reprint them?'}
				</div>
			</div>
			<iframe
				title="Print Pdf Preview"
				type="application/pdf"
				id="PdfViewer"
				src={formUrls[0]}
				width="100%"
				height="250"
			/>
		</Modal>
	);
};

export default withLayoutAndModalContexts(FormsModal);
